import resource from '@/utils/pages/resources';

export default resource({
  namespace: ['admin'],
  store: { url: 'users' },
  name: 'user',
  key: 'email',
  attributes: [
    ['email', { form: { validate: { required: true, email: true } } }],
  ],
  form: {
    fields: [
      ['password', { required: true }],
    ],
  },
});
